import { UPGRADE_MESSAGING_CHANGED } from '../../../actions/upgradeMessaging';

import type { ActionType } from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';

export type UpgradeMessagingState = boolean;

export const INITIAL_STATE: UpgradeMessagingState = false;

export default function upgradeMessaging(
  state: UpgradeMessagingState = INITIAL_STATE,
  action: ActionType,
): UpgradeMessagingState {
  switch (action.type) {
    case UPGRADE_MESSAGING_CHANGED:
      return action.payload;

    default:
      return state;
  }
}

export const get = (state: UpgradeMessagingState): UpgradeMessagingState => state;
